import { OperationReportForm32Component } from "../../../components/SupportSystem/OperationReportForm/OperationReportForm32Component"
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
export function OperationReportForm32Container () {
    const titleName = "แบบรายงานการดำเนินการพัฒนาฝีมือแรงงานของผู้ได้รับเงินช่วยเหลือหรืออุดหนุน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <OperationReportForm32Component/>
            <Footer />
        </div>   
    )
}